var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import { createContainer } from 'unstated-next';
import { createTemplate } from '../../../../../api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import t from '../../../../../lib/translate';
var useNewTemplate = function () {
    var _a = useState('SMS'), channel = _a[0], setChannel = _a[1];
    var _b = useState(''), subject = _b[0], setSubject = _b[1];
    var _c = useState(''), body = _c[0], setBody = _c[1];
    var _d = useState('STRING'), format = _d[0], setFormat = _d[1];
    var _e = useState(''), ownerpartyKey = _e[0], setOwnerpartyKey = _e[1];
    var _f = useState(''), key = _f[0], setKey = _f[1];
    var navigate = useNavigate();
    var createNewTemplate = function (e) {
        e.preventDefault();
        var content = { subject: subject, body: body };
        createTemplate({ ownerpartyKey: ownerpartyKey, channel: channel, key: key, format: format, content: content })
            .then(function (res) {
            toast.success(t('templates.created', res.key));
            navigate("/admin/templates/".concat(res.ownerparty.key, "/").concat(res.key, "/").concat(res.version.replace('.', '_')));
        })
            .catch(function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, error.json()];
                    case 1:
                        body = _a.sent();
                        if (body.errors.length > 0) {
                            body.errors.forEach(function (e) {
                                toast.error(e.errorMessage);
                            });
                        }
                        else {
                            toast.error(t('templates.failed.to.save'));
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return {
        channel: channel,
        subject: subject,
        format: format,
        ownerpartyKey: ownerpartyKey,
        key: key,
        body: body,
        setChannel: setChannel,
        setSubject: setSubject,
        setFormat: setFormat,
        setOwnerpartyKey: setOwnerpartyKey,
        setKey: setKey,
        setBody: setBody,
        createNewTemplate: createNewTemplate
    };
};
var NewTemplate = createContainer(useNewTemplate);
export default NewTemplate;
